(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4153],{

/***/ 28626:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/property-management",
      function () {
        return __webpack_require__(69582);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 72560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var PropertyFiltersContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
/* harmony default export */ __webpack_exports__["Z"] = (PropertyFiltersContext);


/***/ }),

/***/ 10763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LZ": function() { return /* binding */ PER_PAGE; },
/* harmony export */   "Vf": function() { return /* binding */ PRICES; },
/* harmony export */   "Q_": function() { return /* binding */ STATUS; },
/* harmony export */   "sX": function() { return /* binding */ OPERATIONS; },
/* harmony export */   "PG": function() { return /* binding */ PROPERTY_TYPES; },
/* harmony export */   "bA": function() { return /* binding */ TRIGGER_CLOSE_PROPERTY_OPTIONS; },
/* harmony export */   "TP": function() { return /* binding */ labelsPriceAndDate; }
/* harmony export */ });
/* harmony import */ var services_number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58800);

var PER_PAGE = 10;
var PRICES = [
    {
        value: '',
        label: 'Todo'
    },
    {
        value: '5000',
        label: '5,000'
    },
    {
        value: '10000',
        label: '10,000'
    },
    {
        value: '15000',
        label: '15,000'
    },
    {
        value: '20000',
        label: '20,000'
    },
    {
        value: '25000',
        label: '25,000'
    },
    {
        value: '30000',
        label: '30,000'
    },
    {
        value: '35000',
        label: '35,000'
    },
    {
        value: '40000',
        label: '40,000'
    },
    {
        value: '45000',
        label: '45,000'
    },
    {
        value: '50000',
        label: '50,000'
    },
    {
        value: '100000',
        label: '100,000'
    },
    {
        value: '200000',
        label: '200,000'
    },
    {
        value: '300000',
        label: '300,000'
    },
    {
        value: '400000',
        label: '400,000'
    },
    {
        value: '500000',
        label: '500,000'
    },
    {
        value: '600000',
        label: '600,000'
    },
    {
        value: '700000',
        label: '700,000'
    },
    {
        value: '800000',
        label: '800,000'
    },
    {
        value: '900000',
        label: '900,000'
    },
    {
        value: '1000000',
        label: '1M'
    },
    {
        value: '1100000',
        label: '1.1M'
    },
    {
        value: '1200000',
        label: '1.2M'
    },
    {
        value: '1300000',
        label: '1.3M'
    },
    {
        value: '1400000',
        label: '1.4M'
    },
    {
        value: '1500000',
        label: '1.5M'
    },
    {
        value: '1600000',
        label: '1.6M'
    },
    {
        value: '1700000',
        label: '1.7M'
    },
    {
        value: '1800000',
        label: '1.8M'
    },
    {
        value: '1900000',
        label: '1.9M'
    },
    {
        value: '2000000',
        label: '2.0M'
    },
    {
        value: '1250000',
        label: '2.25M'
    },
    {
        value: '1500000',
        label: '2.5M'
    },
    {
        value: '1750000',
        label: '2.75M'
    },
    {
        value: '3000000',
        label: '3M'
    },
    {
        value: '35000000',
        label: '3.5M'
    },
    {
        value: '4000000',
        label: '4M'
    },
    {
        value: '5000000',
        label: '5M'
    },
    {
        value: '10000000',
        label: '10M'
    }
];
var STATUS = [
    {
        value: 'APPROVED',
        label: 'Aprobada'
    },
    {
        value: 'PENDING_FOR_APPROVAL',
        label: 'En revisi\xf3n'
    },
    {
        value: 'USER_REVIEW_NEEDED',
        label: 'Rechazada'
    },
    {
        value: 'DRAFT',
        label: 'Borrador'
    },
    {
        value: 'CLAIMED',
        label: 'PDC'
    }
];
var OPERATIONS = [
    {
        value: 'SELL',
        label: 'Venta'
    },
    {
        value: 'RENT',
        label: 'Renta'
    }
];
var PROPERTY_TYPES = [
    {
        label: 'Departamento',
        value: 'APARTMENT'
    },
    {
        label: 'Casa',
        value: 'HOUSE'
    },
    {
        label: 'Terreno',
        value: 'LOTS'
    },
    {
        label: 'Cuarto',
        value: 'ROOMS'
    },
    {
        label: 'Local',
        value: 'STORE'
    },
    {
        label: 'Bodega',
        value: 'WAREHOUSE'
    },
    {
        label: 'Oficina',
        value: 'OFFICE'
    }
];
var TRIGGER_CLOSE_PROPERTY_OPTIONS = [
    'REMOVE_SOLD_ME',
    'REMOVE_SOLD_NEXIMER',
    'REMOVE_SOLD_OTHER'
];
var labelsPriceAndDate = function(obj, key) {
    if (key === 'price__amount__lte') {
        return("M\xe1ximo ".concat((0,services_number__WEBPACK_IMPORTED_MODULE_0__/* .formatCurrency */ .xG)(obj[key])));
    }
    if (key === 'price__amount__gte') {
        return("M\xednimo ".concat((0,services_number__WEBPACK_IMPORTED_MODULE_0__/* .formatCurrency */ .xG)(obj[key])));
    }
    if (key === 'created_at__gte') {
        return("Desde ".concat(obj[key]));
    }
    if (key === 'created_at__lte') {
        return("Hasta ".concat(obj[key]));
    }
};


/***/ }),

/***/ 69582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var components_Layout_Admin__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98946);
/* harmony import */ var components_PropertyManagement_PropertyFiltersContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72560);
/* harmony import */ var components_PropertyManagement_config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10763);







function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var DashboardContent = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_2__["default"])(function() {
    return __webpack_require__.e(/* import() */ 7716).then(__webpack_require__.bind(__webpack_require__, 97716));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97716)
            ];
        }
    },
    ssr: false
});
var PropertyManagement = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_2__["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7833), __webpack_require__.e(8797), __webpack_require__.e(4368)]).then(__webpack_require__.bind(__webpack_require__, 34368));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34368)
            ];
        }
    },
    ssr: false
});
var PropertyManagementPage = function(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var filters = queryToFilters(router.query);
    var _url = props.url, query = _url.query, pathname = _url.pathname;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Layout_Admin__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        pageRoles: [
            'BROKER'
        ],
        urlData: {
            query: query,
            pathname: pathname
        },
        title: "Gesti\xf3n de propiedades",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DashboardContent, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_PropertyManagement_PropertyFiltersContext__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Provider */ .Z.Provider, {
                value: filters,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PropertyManagement, {
                    filters: filters
                })
            })
        })
    }));
};
var queryToFilters = function(query) {
    var page = query.page, property_type = query.property_type, operation_type = query.operation_type, search = query.search, status = query.status, price__amount__lte = query.price__amount__lte, price__amount__gte = query.price__amount__gte, created_at__gte = query.created_at__gte, created_at__lte = query.created_at__lte;
    var offset = page ? (parseInt(page) - 1) * components_PropertyManagement_config__WEBPACK_IMPORTED_MODULE_6__/* .PER_PAGE */ .LZ : 0;
    var params = search ? {
        search: search
    } : {
        status: status,
        property_type: property_type,
        operation_type: operation_type,
        price__amount__lte: price__amount__lte,
        price__amount__gte: price__amount__gte,
        created_at__gte: created_at__gte,
        created_at__lte: created_at__lte
    };
    var filters = _objectSpread({}, params, {
        offset: offset,
        limit: components_PropertyManagement_config__WEBPACK_IMPORTED_MODULE_6__/* .PER_PAGE */ .LZ
    });
    return filters;
};
PropertyManagementPage.getInitialProps = function(context) {
    return {};
};
/* harmony default export */ __webpack_exports__["default"] = (PropertyManagementPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,4663,4895,9179,6940,3055,866,6066,7314,6959,9994,604,3300,4608,5206,2174,2470,553,7013,2593,2888,179], function() { return __webpack_exec__(28626); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);